import { useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../stores/root_store';
//import useCollabs from '../hooks/useCollabs';

import CollabCreate from './CollabCreate';
import CollabWorkSpace from './CollabWorkSpace';
import useUserIdentity from '../hooks/useUserIdentity';
const CollabFrame = observer(() => {
    const { projectKey = "" } = useParams<{ projectKey: string }>();
    const { collabKey = "" } = useParams<{ collabKey: string }>();
    const projectStore = useContext(RootStoreContext).projectStore;
    const project = projectStore.getProject(projectKey);
    const { currentIdentity} = useUserIdentity();
    const navigate = useNavigate();

    if(!currentIdentity) {
        return null;
    }

    useEffect(() => {
        if (currentIdentity?.role && currentIdentity.role !== 'client') {
            navigate(`/collab/${collabKey}`);
        }
    }, [currentIdentity?.role]);

    if(!project) {
        return null;
    }

	if (collabKey == 'new') {
		return <CollabCreate project={project} />
	}
	else {
        return <CollabWorkSpace collabKey={collabKey} />
	}
});


export default CollabFrame;
